// extracted by mini-css-extract-plugin
export default {"titleContainer":"styles_titleContainer__YmmI5","title":"styles_title__sFy5Y","footer":"styles_footer__Q4lcv"};